import $ from 'jquery';
import Em from 'ember';
function Renderer($editor) {
  this.$editor = $editor;
}
Renderer.prototype = {
  render($composerStateHtml) {
    Em.instrument('Composer.lib.render', null, function () {
      this.composerStateBlockStack = $($composerStateHtml).toArray();
      this.editorBlockStack = this.$editor.children().toArray();
      //eslint-disable-next-line no-constant-condition
      while (true) {
        if (this.composerStateBlockStack.length === 0 || this.editorBlockStack.length === 0) {
          this.removeBlocksFromEditor(this.editorBlockStack);
          this.addBlocksToEditor(this.composerStateBlockStack);
          break;
        }
        this.processBlocks(this.editorBlockStack.shift(), this.composerStateBlockStack.shift());
      }
    }.bind(this));
  },
  processBlocks(editorBlock, composerStateBlock) {
    if (isSameBlock(editorBlock, composerStateBlock)) {
      this.updateBlock(composerStateBlock);
      return;
    }
    let indexOfEditorBlockInComposerState = this.findInComposerState(editorBlock);
    if (indexOfEditorBlockInComposerState === -1) {
      this.processRemovedEditorBlock(editorBlock, composerStateBlock);
    } else {
      this.processInsertedComposerStateBlock(editorBlock, composerStateBlock, indexOfEditorBlockInComposerState);
    }
  },
  processInsertedComposerStateBlock(editorBlock, composerStateBlock, insertUpTo) {
    this.insertSliceIntoEditor(editorBlock, composerStateBlock, insertUpTo);
    composerStateBlock = this.composerStateBlockStack.shift();
    this.processBlocks(editorBlock, composerStateBlock);
  },
  processRemovedEditorBlock(editorBlock, composerStateBlock) {
    this.removeBlockFromEditor(editorBlock);
    editorBlock = this.editorBlockStack.shift();
    if (editorBlock) {
      this.processBlocks(editorBlock, composerStateBlock);
    } else {
      this.addBlockToEditor(composerStateBlock);
    }
  },
  updateBlock(composerStateBlock) {
    let id = composerStateBlock.attributes.getNamedItem('data-id').value;
    let selector = `[data-id="${id}"]`;
    let $existingBlock = this.$editor.find(selector);
    if (!isSameVersion($existingBlock[0], composerStateBlock)) {
      $existingBlock.replaceWith(composerStateBlock);
    }
  },
  findInComposerState(editorBlock) {
    for (let i = 0; i < this.composerStateBlockStack.length; i++) {
      if (isSameBlock(editorBlock, this.composerStateBlockStack[i])) {
        return i;
      }
    }
    return -1;
  },
  insertSliceIntoEditor(editorBlock, composerStateBlock, index) {
    let matchedBlocks = this.composerStateBlockStack.slice(0, index);
    matchedBlocks.unshift(composerStateBlock);
    this.composerStateBlockStack = this.composerStateBlockStack.slice(index);
    this.addBlocksToEditor(matchedBlocks, editorBlock);
  },
  addBlocksToEditor(blocks, beforeBlock) {
    blocks.forEach(function (block) {
      this.addBlockToEditor(block, beforeBlock);
    }, this);
  },
  addBlockToEditor(block, beforeBlock) {
    if (beforeBlock) {
      this.$editor.find(beforeBlock).before(block);
    } else {
      this.$editor.append(block);
    }
  },
  removeBlocksFromEditor(blocks) {
    blocks.forEach(function (block) {
      this.removeBlockFromEditor(block);
    }, this);
  },
  removeBlockFromEditor(block) {
    try {
      this.$editor[0].removeChild(block);
    } catch (e) {
      // The node may have been remove already by an event handler
      // Make sure it's really gone and carry on
      let id = $(block).data('id');
      this.$editor.remove(`[data-id="${id}"]`);
    }
  }
};
function isSameBlock(block1, block2) {
  return attributeMatches(block1, block2, 'data-id');
}
function isSameVersion(block1, block2) {
  return attributeMatches(block1, block2, 'data-generated-at');
}
function attributeMatches(block1, block2, attr) {
  let attr1 = block1.attributes.getNamedItem(attr);
  let attr2 = block2.attributes.getNamedItem(attr);
  return attr1 && attr2 && attr1.value === attr2.value;
}
export default Renderer;